<template>
  <Teleport to="body">
    <section
      v-if="showRisk"
      class="fixed inset-0 z-[9999] box-border grid place-items-center overflow-y-auto bg-[#fff] p-[30px]"
    >
      <div
        class="relative min-h-[430px] w-[940px] max-w-full rounded-[20px] border border-solid border-[#B23636] bg-[#FCF7F7]"
      >
        <div
          class="mx-[1px] mt-[1px] min-h-[110px] w-[calc(100%-2px)] rounded-[20px_20px_0px_0px] bg-[#B23636] px-[42px] py-[25px]"
        >
          <div class="text-[20px] leading-[30px] font-light text-[#fff]">
            {{ panelContent.ipPrefix }}
            <span class="font-semibold text-[#fff]">{{ panelContent.ipRegion }}</span>
            {{ panelContent.noticeSuffix }}
          </div>
          <div class="text-[20px] leading-[30px] font-light text-[#fff]">{{ panelContent.complianceText }}</div>
        </div>
        <div class="mx-[42px] mt-[36px] text-[24px] font-semibold text-[#B23636]">
          {{ panelContent.title }}
        </div>
        <div class="mx-[42px] mt-[8px] text-[18px] leading-[27px] text-[#B23636]">
          {{ panelContent.description }}
        </div>
        <CommonImage
          src="https://resources1.interface003.com/web20/img/othor/red_bg_br.png"
          alt=""
          class="absolute right-0 bottom-0 z-[2] h-[197px] w-[287px] cursor-pointer"
          @click="eventclick"
        />
        <CommonImage
          src="https://resources1.interface003.com/web20/img/othor/red_bg_bt.png"
          alt=""
          class="absolute bottom-0 left-[10px] w-[calc(100%-20px)]"
        />
      </div>
    </section>
  </Teleport>
</template>

<script setup lang="ts">
import { getCookieDomain } from '../../utils/cookieDomain'
import axios from 'axios'
const appStore = useAppStore()
const bypassCookie = useCookie<number | null>('jgpass_new', {
  path: '/',
  domain: getCookieDomain(),
  expires: new Date(Date.now() + 720 * 60 * 1000),
})

const showRisk = ref(false)
const clickCount = ref(0)

let imgCheckPing: HTMLImageElement | null = null
let pingTimeout: ReturnType<typeof setTimeout> | null = null
let resetCountTimer: ReturnType<typeof setTimeout> | null = null
let handlePingLoad: (() => void) | null = null
let handlePingError: (() => void) | null = null

const panelContent = {
  ipPrefix: '您的IP为',
  ipRegion: '中国大陆地区',
  noticeSuffix: '，抱歉的通知您，不能为您提供服务，还请谅解。',
  complianceText: '请遵守当地法律。',
  title: '您正在访问的是WikiBit网站。',
  description: 'WikiBit互联网及其移动产品是一款面向全球发行的企业金融资讯查询工具。',
}

const clearPingCheck = () => {
  if (pingTimeout) {
    clearTimeout(pingTimeout)
    pingTimeout = null
  }

  if (imgCheckPing) {
    if (handlePingLoad) {
      imgCheckPing.removeEventListener('load', handlePingLoad)
      handlePingLoad = null
    }

    if (handlePingError) {
      imgCheckPing.removeEventListener('error', handlePingError)
      handlePingError = null
    }

    imgCheckPing = null
  }
}

const isSafariBrowser = () => /Safari/.test(window.navigator.userAgent) && !/Chrome/.test(window.navigator.userAgent)

const pingGoogleIcon = (onSuccess: () => void, onFailure: () => void) => {
  clearPingCheck()

  let hasFinished = false
  const finish = (callback: () => void) => {
    if (hasFinished) return
    hasFinished = true
    clearPingCheck()
    callback()
  }

  imgCheckPing = new Image()
  imgCheckPing.src = `https://www.google.com/favicon.ico?${Math.random()}`
  handlePingLoad = () => finish(onSuccess)
  handlePingError = () => finish(onFailure)
  imgCheckPing.addEventListener('load', handlePingLoad)
  imgCheckPing.addEventListener('error', handlePingError)

  pingTimeout = setTimeout(() => {
    if (!imgCheckPing) {
      finish(onFailure)
      return
    }

    imgCheckPing.src = 'https://resources1.interface003.com/web20/img/favicon-wikifx.ico'
    finish(onFailure)
  }, 1500)
}

const getRiskModule = (currentCountry: string) => {
  clearPingCheck()
  showRisk.value = false

  if (bypassCookie.value === 1) return

  if (currentCountry === 'cn') {
    if (isSafariBrowser()) {
      showRisk.value = true
      return
    }

    pingGoogleIcon(
      () => {
        showRisk.value = false
      },
      () => {
        showRisk.value = true
      },
    )
    return
  }
}

const setBypassCookie = () => {
  bypassCookie.value = 1
}

const eventclick = () => {
  clickCount.value += 1

  if (clickCount.value === 1) {
    resetCountTimer = setTimeout(() => {
      clickCount.value = 0
      resetCountTimer = null
    }, 30000)
  }

  if (clickCount.value < 7) return

  setBypassCookie()
  window.location.reload()
}

onMounted(async () => {
  try {
    const ret = await axios.get(`https://exportedbase.${TECH002}/ip`)
    const currentCountry = ret?.data?.result?.country_code || ''
    // console.log('currentCountry', currentCountry)
    getRiskModule(currentCountry)
  } catch {}
})

onBeforeUnmount(() => {
  clearPingCheck()
  if (resetCountTimer) {
    clearTimeout(resetCountTimer)
    resetCountTimer = null
  }
})
</script>
